import { Card, Divider, Grid, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import VerifyCarnetController from "./controllers/VerifyCarnetController";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";

function Verify() {
  /*  const imageUrl = "src/layouts/welcome/images/logo.jpeg"; */
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h3" color="white">
                  Verificar carnets
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <div style={{ marginTop: "64px", textAlign: "center" }}>
                  <VerifyCarnetController></VerifyCarnetController>
                </div>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Verify;
